const fs = require('fs');
const path = require('path');
const { replaceColorsWithSmetioDataAttributesInSvg } = require('../replace/replaceColorsWithSmetioDataAttributesInSvg');

// import {svg} from "./../../../../production/img/appImages/SVG/personalDetails"

const getTxtFileFromSvg = async (params) => {

    const imagePath = "../../../../production/img/appImages/SVG/";


    fs.readdir(path.resolve(__dirname, imagePath), (err, files) => {

        if (err) {
            console.log(err);
            return;
        };
        console.log("The files are: ", files);
        files.forEach(file => {
            console.log(file);

            const fileName = path.parse(file).name;
            const extension = path.parse(file).ext;
            if (extension !== ".svg") return true;

            // const jsVersionExists = fs.existsSync(`${imagePath}${fileName}.js`);
            const txtVersionExists = fs.existsSync(`${imagePath}${fileName}.txt`);

            // if (jsVersionExists) return true;
            if (txtVersionExists) return true;

            replaceColorsWithSmetioDataAttributesInSvg({
                imagePath: "../../../../production/img/appImages/SVG/",
                imageName: fileName,
            });

        });
    });



    // const colors = {
    //     dominant:["#102040","#0f203f"], 
    //     accent:["#96b3d9"], 
    //     warning:["#dfc08b"], 
    //     neutral:["#e9eff7"]
    // };
    // // const properties = ['fill', 'stroke']
    // // const replacements = {
    // //     fill: ["#102040", "#96b3d9", "#0f203f", "#dfc08b", "#e9eff7" ]
    // // };

    // const imagePath = "../../../../production/img/appImages/SVG/";
    // const imageName = "personalDetails_test";
    // const image  = `${imagePath}${imageName}.svg`;

    // // Below statements must be wrapped inside the 'async' function:
    // const data = await fs.readFile(path.resolve(__dirname, image), 'utf8');

    // let newContent = data;

    // for (const key in colors) {

    //     console.log("The key is: " + key);

    //     const colorArr = colors[key];

    //     for (let i = 0; i < colorArr.length; i++) {
    //         const colorCode = colorArr[i];
    //         let replaceFill = `fill="${colorCode}"`;
    //         replaceFill = new RegExp(replaceFill, "g");

    //         let replaceStroke = `stroke="${colorCode}"`;
    //         replaceStroke = new RegExp(replaceStroke, "g");


    //         newContent = newContent.replaceAll(replaceFill, `data-smetio-${key}-fill=true`);
    //         newContent = newContent.replaceAll(replaceStroke, `data-smetio-${key}-stroke=true`);
    //     };

    // };

    // const jsFile = `${imagePath}${imageName}.js`
    // const jsFileContent = `
    //     export default function ${imageName}() {

    //         return\`
    //             ${newContent}
    //         \`;
    //     }
    // `;

    // fs.writeFile(path.resolve(__dirname, jsFile),  jsFileContent, function (err) {
    //     if (err) throw err;
    //     console.log( 'js file created');
    // });

    // const result = data.replace(/string to be replaced/g, 'replacement');
    // await fs.writeFile(someFile, result, 'utf8');



};
getTxtFileFromSvg();